import React, { useEffect, useState } from "react";
import { homepageRoute } from "@/routing";
import { CargoMindsSmallLogo, Spinner } from "@/components/common/svgs";
import { Link, useSearchParams } from "react-router";
import { TranslatedText } from "@/components/common/text";
import { useNavigate } from "react-router";
import { TextInput } from "@/components/common/inputs";
import { Button } from "@/components/common/buttons";
import { useSelector, useDispatch } from "react-redux";
import { loginUserWithCredentials, logoutUser } from "@/auth/authSlice";
import { ErrorText } from "@/components/common/errors";
import isEmail from "validator/es/lib/isEmail";
import { cn } from "@/utils/css";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";

export const Login = () => {
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [doneLogin, setDoneLogin] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [searchParams] = useSearchParams();
    const isDarkTheme = useIsDarkTheme();

    const handleLogin = (e) => {
        e.preventDefault();
        if (!isEmail(email)) {
            setValidationError("Invalid email");
        } else if (!password) {
            setValidationError("Please enter password");
        } else {
            dispatch(
                loginUserWithCredentials({
                    email,
                    password,
                }),
            )
                .unwrap()
                .then(() => {
                    setDoneLogin(true);
                });
        }
    };

    const handleLogout = async () => {
        dispatch(logoutUser());
    };

    useEffect(() => {
        if (doneLogin && user.data) {
            const returnUrl = decodeURIComponent(searchParams.get("returnUrl") || "");
            navigate(`/${returnUrl}`);
        }
    }, [doneLogin, user.data]);

    return (
        <div className="flex w-full items-center justify-center min-h-[calc(100vh-2rem)] flex-col px-6">
            <div className="bg-cm-p-surface w-full sm:max-w-[476px] rounded-lg text-cm-p-text-primary flex flex-col items-center justify-center min-h-[452px]">
                {user.data !== undefined ? (
                    user.data ? (
                        <div className="flex flex-col items-center justify-center gap-4 mt-4">
                            <div className="w-full flex flex-col items-center justify-center">
                                <Link to={homepageRoute} className="h-9 w-[80px] mb-5">
                                    <CargoMindsSmallLogo />
                                </Link>
                                <div className="text-[32px] leading-9 text-cm-p-text-primary font-medium mb-14">
                                    <TranslatedText>Login to CargoMinds</TranslatedText>
                                </div>
                            </div>
                            <p>Welcome, {user.data.email}</p>
                            <button onClick={handleLogout}>Logout</button>
                        </div>
                    ) : (
                        <div
                            className={cn("w-full pb-10 px-6 py-8 sm:px-12 sm:py-12 bg-cm-p-surface text-cm-p-text-primary rounded-lg", {
                                "shadow-login-light": !isDarkTheme,
                            })}
                        >
                            <div className="w-full flex flex-col items-center justify-center">
                                <Link to={homepageRoute} className="h-9 w-[80px] mb-5">
                                    <CargoMindsSmallLogo />
                                </Link>
                                <div className="text-[32px] leading-9 text-cm-p-text-primary font-medium mb-14">
                                    <TranslatedText>Login to CargoMinds</TranslatedText>
                                </div>
                            </div>
                            <form className={"gap-6 flex flex-col mb-6 md:max-w-[380px]"} onSubmit={handleLogin}>
                                <TextInput
                                    name="email"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    setValue={setEmail}
                                    autoComplete="username"
                                    autoFocus
                                />
                                <ErrorText text={validationError || user.error} />
                                <TextInput
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    setValue={setPassword}
                                    autoComplete="password"
                                    reqiured="true"
                                />
                                <div className="text-right -mt-4">
                                    <Link to="/forgot-password" className="text-sm text-cm-p-primary hover:underline">
                                        <TranslatedText>Forgot password?</TranslatedText>
                                    </Link>
                                </div>
                                <div className="h12">
                                    <Button disabled={user.loading} type="submit">
                                        {user.loading ? <Spinner className="w-5 h-5" /> : "Log In"}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    )
                ) : null}
            </div>
        </div>
    );
};
